import type { MutationTree } from 'vuex'
import type { LocationState, UpdateLocationPayload } from './types'
import { LOCATION_MUTATIONS } from './types'

interface ILocationMutations extends MutationTree<LocationState> {
  [LOCATION_MUTATIONS.START_UPDATING_LOCATION](state: LocationState): void
  [LOCATION_MUTATIONS.STOP_UPDATING_LOCATION](state: LocationState): void
  [LOCATION_MUTATIONS.UPDATE_LOCATION](state: LocationState, payload: UpdateLocationPayload): void
  [LOCATION_MUTATIONS.DISALLOW_LOCATION](state: LocationState): void
}

const mutations: ILocationMutations = {
  [LOCATION_MUTATIONS.START_UPDATING_LOCATION](state) {
    state.loading = true
  },
  [LOCATION_MUTATIONS.STOP_UPDATING_LOCATION](state) {
    state.loading = false
  },
  [LOCATION_MUTATIONS.UPDATE_LOCATION](state, coords: UpdateLocationPayload) {
    state.lat = coords.lat
    state.lng = coords.lng
    state.allowed = true
  },
  [LOCATION_MUTATIONS.DISALLOW_LOCATION](state) {
    state.allowed = false
  }
}

export default mutations
